const getLogoutUrl = () => {
  return (
    process.env.REACT_APP_SSO_LOGOUT_URL ||
    'https://jjdstnjwch-vpce-063282340477e592a.execute-api.us-west-2.amazonaws.com/qa'
  );
};

module.exports = getLogoutUrl;
